import React, { useState } from "react";
import CompletionPopup from "../completion-popup";
import { logEvent } from '@firebase/analytics';
import {analytics} from '../../config/firebase-logging';
import { useCareerContext } from '../career-context';

export function QuizGrading() {
    const {
        isPopupOpen,
        setIsPopupOpen,
        handleError,
        handleNotification,
        startConfetti
    } = useCareerContext();

    const [selectedProblems, setSelectedProblems] = useState([])
    const [output, setOutput] = useState("")

    function handleSelectProblem(problem) {
        if (selectedProblems.includes(problem)) {
            setSelectedProblems(selectedProblems.filter(p => p !== problem))
        } else {
            setSelectedProblems([...selectedProblems, problem])
        }   
    }

    function handleGrading(e) {
        e.preventDefault()
        
        if (process.env.REACT_APP_ENVIRONMENT === "production") {
            logEvent(analytics, 'career_interaction')
        }
        const isSelectedIncorrectProblems = (selectedProblems.length === 2) && (selectedProblems.includes(5)) && (selectedProblems.includes(4));
        if (!isSelectedIncorrectProblems) {
            setOutput("Not quite! You seem to have selected the wrong problems")
            return
        }
        const grade = parseInt(e.target[0].value);
        if (grade !== 66 && grade !== 67) {
            setOutput("Not quite! You seem to have entered the wrong grade")
            return
        }

        setOutput("")
        setIsPopupOpen(true)
        startConfetti()
    }

    return (
        <div>
            <div className="quiz-grading row">
                <div className="quiz">
                    <div style={{textAlign: "right"}}><label>Name: </label><span className="handwriting">Maya</span></div>
                    <h2 className="blue">7th Grade Fractions Test</h2>
                    <div className="problem" style={{backgroundColor: (selectedProblems.includes(1)) ? "#dadada" : "inherit"}} onClick={()=>handleSelectProblem(1)}>
                        <label>1. What is 4/5 + 2/7?</label>
                        <span className="handwriting">  38/35</span>
                    </div>
                    <div className="problem" style={{backgroundColor: (selectedProblems.includes(2)) ? "#dadada" : "inherit"}} onClick={()=>handleSelectProblem(2)}>
                        <label>2. What is 1/6 + 8/12?</label>
                        <span className="handwriting">  5/6</span>
                    </div>
                    <div className="problem" style={{backgroundColor: (selectedProblems.includes(3)) ? "#dadada" : "inherit"}} onClick={()=>handleSelectProblem(3)}>
                        <label>3. What is 1/4 - 2/3</label>
                        <span className="handwriting">  -5/12</span>
                    </div>
                    <div className="problem" style={{backgroundColor: (selectedProblems.includes(4)) ? "#dadada" : "inherit"}} onClick={()=>handleSelectProblem(4)}>
                        <div>
                            <label>4. What is 2<sup>9</sup>&frasl;<sub>13</sub> - 4/9?</label>
                            <span className="handwriting">  263/115</span>
                        </div>
                        <span className="handwriting"> 35/13 - 4/9   = 315/115 - 52/115 = 263/115 </span>
                    </div>
                    <div className="problem" style={{backgroundColor: (selectedProblems.includes(5)) ? "#dadada" : "inherit"}} onClick={()=>handleSelectProblem(5)}>
                        <label>5. What is 3/11 - 8/11?</label>
                        <span className="handwriting">  5/11</span>
                    </div>
                    <div className="problem" style={{backgroundColor: (selectedProblems.includes(6)) ? "#dadada" : "inherit"}} onClick={()=>handleSelectProblem(6)}>
                        <label>6. What is 4/3 + 2/5?</label>
                        <span className="handwriting">  26/15</span>
                    </div>
                </div>
                
                <div className="grading">
                    <form onSubmit={handleGrading}> 
                        <p><strong>1. Select all incorrect questions</strong></p>
                        <p><strong>2. Enter the student's grade (as a percentage to the nearest whole number)</strong></p>
                        <div className="frq" style={{margin: "0"}}>
                            <input type="number" required={true} placeholder="Enter a percentage, like 77" />

                        </div>
                        <div style={{margin: "20px 0px"}}>
                            <button className="primary-btn">Check</button>
                        </div>
                    </form>
                    {output && <p>{output}</p>}

                    
                </div>
            </div>
            { isPopupOpen && <CompletionPopup title="Great Job!" message="You successfully graded the quiz!" hidePopup={()=>setIsPopupOpen(false)}/>}
        </div>
    )
}